import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiCogOutline, mdiFilterOutline } from "@mdi/js";
import { Button, SearchField, Tabs } from "@heroui/react";
import { ROUTES } from "@/constants/routes";
import { helpStore } from "@/stores/HelpStore";
import HelpTable from "./components/HelpTable";
import HelpOrderDrawer from "./components/HelpOrderDrawer";
import {
  formatHelpMoney,
  HELP_SERVICE_KIND_COMING_SOON,
  HELP_SERVICE_KIND_LABEL,
  HELP_SERVICE_KIND_OPTIONS,
} from "./constants";
import "./HelpPage.css";

const HelpPage: React.FC = observer(() => {
  const navigate = useNavigate();
  const { displayMetrics, isLoading } = helpStore;

  useEffect(() => {
    void helpStore.loadOrders();
  }, []);

  const metricCards = [
    { label: "Активные", value: String(displayMetrics.active) },
    {
      label: "Ждут диспетчера",
      value: String(displayMetrics.awaiting_dispatcher),
    },
    { label: "Через ЛАТ", value: String(displayMetrics.through_lat) },
    { label: "Предоплата", value: formatHelpMoney(displayMetrics.prepaid_sum) },
  ];

  return (
    <div className="help-page" data-testid="help-page">
      <div className="help-page__toolbar" data-testid="help-toolbar">
        <div className="help-page__toolbar-left">
          <div
            className="help-page__disabled-control help-page__search"
            data-testid="help-search"
            aria-disabled="true"
            title="Скоро"
          >
            <SearchField
              isDisabled
              value=""
              aria-label="Поиск заявок помощи"
            >
              <SearchField.Group>
                <SearchField.SearchIcon />
                <SearchField.Input placeholder="Клиент, телефон, номер авто..." />
              </SearchField.Group>
            </SearchField>
          </div>
          <div
            className="help-page__disabled-control"
            aria-disabled="true"
            title="Скоро"
          >
            <Button
              isIconOnly
              isDisabled
              variant="tertiary"
              aria-label="Фильтры"
              className="icon-btn--card"
            >
              <Icon path={mdiFilterOutline} size={0.85} />
            </Button>
          </div>
        </div>
        <Button
          isIconOnly
          variant="ghost"
          className="icon-btn--card"
          aria-label="Настройки помощи"
          data-testid="help-settings-button"
          onPress={() => navigate(ROUTES.HELP_SETTINGS)}
        >
          <Icon path={mdiCogOutline} size={0.9} />
        </Button>
      </div>

      <Tabs selectedKey={helpStore.serviceKind} data-testid="help-service-kind-tabs">
        <Tabs.ListContainer>
          <Tabs.List aria-label="Тип услуги">
            {HELP_SERVICE_KIND_OPTIONS.map((kind) => (
              <Tabs.Tab
                key={kind}
                id={kind}
                isDisabled={HELP_SERVICE_KIND_COMING_SOON[kind]}
              >
                {HELP_SERVICE_KIND_LABEL[kind]}
                {HELP_SERVICE_KIND_COMING_SOON[kind] ? (
                  <span className="help-kind-soon">скоро</span>
                ) : null}
                <Tabs.Indicator />
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Tabs.ListContainer>
      </Tabs>

      <div className="help-metrics" aria-busy={isLoading} data-testid="help-metrics">
        {metricCards.map((metric) => (
          <div key={metric.label} className="help-metric-card">
            <span className="help-metric-card__label">{metric.label}</span>
            <span className="help-metric-card__value">{metric.value}</span>
          </div>
        ))}
      </div>

      <div className="help-page__table-wrap" data-testid="help-table-wrap">
        <HelpTable />
      </div>
      <HelpOrderDrawer />
    </div>
  );
});

HelpPage.displayName = "HelpPage";
export default HelpPage;
